import { Component, Input, output } from '@angular/core';
import { type TailoredWidgetConfig, TailoredWidgetType } from '../../interfaces/TailoredWidget.interface';
import { BasicWidgetSpawnerComponent } from '../basic-widgets/basic-widget-spawner/basic-widget-spawner';
import { BusinessIntelligenceWidgetSpawnerComponent } from '../business-intelligence-widget-spawner/business-intelligence-widget-spawner';
import { TemplateWidgetSpawnerComponent } from '../template-widgets/template-widget-spawner/template-widget-spawner';
import { WidgetSpawnerComponent } from '../widgets/widget-spawner/widget-spawner';

@Component({
    styleUrls: ['./tailored-widget-spawner.scss'],
    selector: 'tailored-widget-spawner',
    templateUrl: 'tailored-widget-spawner.html',
    imports: [
        BusinessIntelligenceWidgetSpawnerComponent,
        TemplateWidgetSpawnerComponent,
        BasicWidgetSpawnerComponent,
        WidgetSpawnerComponent
    ]
})
export class TailoredWidgetSpawnerComponent {
    @Input() widgetConfig!: TailoredWidgetConfig;
    @Input() context!: Record<string, any>;
    @Input() position: { x: number; y: number } = { x: 0, y: 0 };

    dataPointCount = output<number>();

    TailoredWidgetType = TailoredWidgetType;
}
